(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1372],{

/***/ 17436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M5 5.43994L12 12.4399M19 19.4399L12 12.4399M12 12.4399L19 5.43994L5 19.4399",
    stroke: "current-stroke",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgClose);

/***/ }),

/***/ 13908:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pelatihan-mandiri/modul/[modul]/post-test/[[...session]]",
      function () {
        return __webpack_require__(26143);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S_": function() { return /* binding */ DesktopLayout; },
/* harmony export */   "nc": function() { return /* binding */ WithLayoutListener; }
/* harmony export */ });
/* unused harmony exports useDesktopSubmenuHook, WithDesktopLayout */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _wartek_id_header_bar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89140);
/* harmony import */ var _wartek_id_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21958);
/* harmony import */ var _wartek_id_text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89004);








var PELATIHAN_MANDIRI_PATH = "/pelatihan-mandiri";
var SUB_MENU_TEMPLATE = {
    FOR_YOU: next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(4842), __webpack_require__.e(1547), __webpack_require__.e(7882), __webpack_require__.e(8085), __webpack_require__.e(6315), __webpack_require__.e(9583)]).then(__webpack_require__.bind(__webpack_require__, 86315));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(86315)
                ];
            }
        },
        ssr: false
    }),
    TOPIK: next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(1651), __webpack_require__.e(4088), __webpack_require__.e(4842), __webpack_require__.e(7882), __webpack_require__.e(8085), __webpack_require__.e(5888)]).then(__webpack_require__.bind(__webpack_require__, 92629));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(92629)
                ];
            }
        },
        ssr: false
    }),
    AKSI_NYATA: next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(4842), __webpack_require__.e(6683), __webpack_require__.e(7882), __webpack_require__.e(9103), __webpack_require__.e(1317)]).then(__webpack_require__.bind(__webpack_require__, 69103)).then(function(template) {
            return template.AksiNyataList;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(69103)
                ];
            }
        },
        ssr: false
    }),
    MODUL: next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(1651), __webpack_require__.e(9291), __webpack_require__.e(6721), __webpack_require__.e(6426), __webpack_require__.e(6014)]).then(__webpack_require__.bind(__webpack_require__, 17422));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(17422)
                ];
            }
        },
        ssr: false
    })
};
var DesktopLayout = function(param) {
    var children = param.children, submenu = param.submenu;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var pathname = router.pathname, query = router.query;
    // TODO: adjust this
    var sideMenu = [
        {
            label: "Seri Pelatihan",
            icon: "book",
            href: "/pelatihan-mandiri",
            active: pathname === "/pelatihan-mandiri" || pathname.includes("/pelatihan-mandiri/seri-pelatihan") || query.from === "learning-series"
        },
        {
            label: "Topik",
            icon: "topic",
            href: "/pelatihan-mandiri/daftar-topik",
            active: pathname === "/pelatihan-mandiri/daftar-topik" || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/modul/[modul]") || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/text/[id]") || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/video/[id]") || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/quiz/[id]") || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/refleksi/[id]") || pathname.includes("/pelatihan-mandiri/topik/[topik]") && query.from !== "learning-series"
        },
        {
            label: "Webinar",
            icon: "live_tv",
            href: "/pelatihan-mandiri/webinar",
            active: pathname.includes("/pelatihan-mandiri/webinar")
        },
        {
            label: "Aksi nyata",
            icon: "batch_prediction",
            href: "/pelatihan-mandiri/daftar-aksi-nyata",
            active: pathname === "/pelatihan-mandiri/daftar-aksi-nyata" || pathname.includes("/pelatihan-mandiri/aksi-nyata")
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col h-screen w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "fixed w-full p-4 flex flex-row items-center bg-white z-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_header_bar__WEBPACK_IMPORTED_MODULE_3__/* .HeaderBarLeftAction */ .l8, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .J, {
                            as: "i",
                            color: "default",
                            children: "arrow_back"
                        }),
                        onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            router.push("/home")
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_header_bar__WEBPACK_IMPORTED_MODULE_3__/* .HeaderBarTitle */ .rF, {
                        children: "Merdeka Mengajar"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-row bg-gray-10 overflow-hidden h-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col w-64 border-r border-gray-200 mt-[80px] px-4",
                        children: sideMenu.map(function(item, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-row items-center p-2 mt-4 rounded-lg cursor-pointer hover:bg-gray-5 ".concat(item.active ? "bg-gray-20" : ""),
                                onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    router.push(item.href)
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .J, {
                                        as: "i",
                                        color: item.active ? "informational" : "default",
                                        className: "mr-4",
                                        children: item.icon
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                        color: item.active ? "primary" : "default",
                                        variant: "heading-sm",
                                        children: item.label
                                    })
                                ]
                            }, "sidemenu-".concat(index));
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "overflow-y-scroll w-[380px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                            className: "mt-8",
                            children: submenu
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1 overflow-y-scroll p-2 max-w-6xl mx-auto md:px-8 lg:px-16",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                            className: "mt-[80px]",
                            children: children && children
                        })
                    })
                ]
            })
        ]
    });
};
var useDesktopSubmenuHook = function(isDesktop) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var pathname = router.pathname;
    var _query = router.query, id = _query.id, from = _query.from, menuId = _query.menuId, topik = _query.topik;
    if (!isDesktop) return null;
    var SubMenuPageMap = [
        {
            path: "".concat(PELATIHAN_MANDIRI_PATH, "/seri-pelatihan/[id]"),
            components: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.FOR_YOU, {
                    isDesktop: true,
                    currentId: id
                })
            }, "seri-pelatihan-dekstop-submenu")
        },
        {
            path: "".concat(PELATIHAN_MANDIRI_PATH, "/topik/[topik]"),
            components: menuId && from === "learning-series" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.FOR_YOU, {
                    isDesktop: true,
                    currentId: menuId
                })
            }, "topik-desktop-submenu") : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.TOPIK, {
                    isDesktop: true,
                    currentId: topik
                })
            }, "topik-desktop-submenu")
        },
        {
            path: "".concat(PELATIHAN_MANDIRI_PATH, "/daftar-aksi-nyata"),
            components: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.AKSI_NYATA, {
                    isDesktop: true
                })
            }, "daftar-aksi-nyata-desktop-submenu")
        },
        {
            path: "".concat(PELATIHAN_MANDIRI_PATH, "/aksi-nyata/[id]"),
            components: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.AKSI_NYATA, {
                    isDesktop: true
                })
            }, "aksi-nyata-desktop-submenu")
        },
        {
            path: [
                "".concat(PELATIHAN_MANDIRI_PATH, "/modul/[modul]"),
                "".concat(PELATIHAN_MANDIRI_PATH, "/text/[id]"),
                "".concat(PELATIHAN_MANDIRI_PATH, "/video/[id]"),
                "".concat(PELATIHAN_MANDIRI_PATH, "/quiz/[id]"),
                "".concat(PELATIHAN_MANDIRI_PATH, "/refleksi/[id]"), 
            ],
            components: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.MODUL, {})
            }, "modul-desktop-submenu")
        }, 
    ];
    var currentSubMenu = SubMenuPageMap.map(function(subMenu) {
        if (typeof subMenu.path === "string") {
            if (pathname.includes(subMenu.path)) {
                return subMenu.components;
            }
        }
        if (Array.isArray(subMenu.path)) {
            if (subMenu.path.some(function(path) {
                return pathname.includes(path);
            })) {
                return subMenu.components;
            }
        }
    });
    return currentSubMenu;
};
var WithDesktopLayout = function(param) {
    var children = param.children;
    var currentSubMenu = useDesktopSubmenuHook(true);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DesktopLayout, {
        submenu: currentSubMenu,
        children: children
    });
};
var WithLayoutListener = function(param) {
    var children = param.children, isDesktop = param.isDesktop;
    if (isDesktop) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WithDesktopLayout, {
            children: children
        });
    }
    return children;
};


/***/ }),

/***/ 26143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_error_boundary__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35800);
/* harmony import */ var react_error_boundary__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_error_boundary__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var app_PelatihanMandiriPage_pages_PostTest__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88785);
/* harmony import */ var components_ErrorBoundary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71130);
/* harmony import */ var app_PelatihanMandiriPage_PostTest_PostTestErrorBoundary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26832);
/* harmony import */ var components_Layout_Desktop_DesktopLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72351);









var PostTestPage = function(props) {
    var isDesktopScreenSize = props.isDesktopScreenSize;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_error_boundary__WEBPACK_IMPORTED_MODULE_7__.ErrorBoundary, {
        resetKeys: [
            router.asPath
        ],
        FallbackComponent: function(param) {
            var error = param.error, resetErrorBoundary = param.resetErrorBoundary;
            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(error, app_PelatihanMandiriPage_PostTest_PostTestErrorBoundary__WEBPACK_IMPORTED_MODULE_5__/* .PostTestContentNotAvailable */ .XV) || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(error, app_PelatihanMandiriPage_PostTest_PostTestErrorBoundary__WEBPACK_IMPORTED_MODULE_5__/* .PostTestCommonError */ .XG)) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(app_PelatihanMandiriPage_PostTest_PostTestErrorBoundary__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                    error: error,
                    resetErrorBoundary: resetErrorBoundary
                });
            } else {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ErrorBoundary__WEBPACK_IMPORTED_MODULE_4__/* .CustomErrorFallback */ .m, {
                    error: error,
                    resetErrorBoundary: resetErrorBoundary
                });
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Layout_Desktop_DesktopLayout__WEBPACK_IMPORTED_MODULE_6__/* .WithLayoutListener */ .nc, {
            isDesktop: isDesktopScreenSize,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(app_PelatihanMandiriPage_pages_PostTest__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .C, {})
        })
    });
};
PostTestPage.layoutOpts = {
    className: "text-default",
    hasHeader: true,
    enableDesktopLayout: true
};
/* harmony default export */ __webpack_exports__["default"] = (PostTestPage);


/***/ }),

/***/ 1413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sz": function() { return /* binding */ getTimestampForGTag; },
  "ps": function() { return /* binding */ minuteToHour; },
  "Sy": function() { return /* binding */ timeAgo; }
});

// UNUSED EXPORTS: formatDate, humanizeDate, isoStringToDateInputTypeFormat, locale, months, youtubeDurationToHms, youtubeDurationToSeconds

// EXTERNAL MODULE: ./node_modules/timeago.js/esm/index.js + 6 modules
var esm = __webpack_require__(52165);
;// CONCATENATED MODULE: ./utils/number.ts
function roundWithPrecision(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}
var random = function(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
};
/**
 * Transforms a number into human-readable format with delimiters every three digits
 * @param {number} number     Number to be transformed
 * @param {string} delimiter  Delimiter character, choose between dots or commas
 *
 * @returns {string} Human-readable number representation with delimiters
 */ function delimit(number) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ".";
    var rgx = /\B(?=(\d{3})+(?!\d))/g;
    var result = "";
    var integerPart = Math.trunc(number);
    var decimalPart = parseFloat((number % 1).toFixed(2));
    var decimalDelimiter = delimiter === "." ? "," : ".";
    result = result + integerPart.toString().replace(rgx, delimiter);
    if (decimalPart) result = result + decimalDelimiter + decimalPart.toString().split(".")[1];
    return result;
}
/**
 * Helper function to render a number in a human-readable format
 * @param {number} num Number to be rendered
 * @param {number} decimals Trailing decimal places to be rendered
 * @param {number} step Multiplier between notations
 * @param {string[]} notations List of notations for the rendered string
 * @returns {string} Human-readable number with notation
 */ function humanizeNumber(num) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, step = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000, notations = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], separator = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    if (num === 0) return "0" + (notations.length > 0 ? " ".concat(notations[0]) : "");
    var dm = decimals < 0 ? 0 : decimals;
    var i = Math.floor(Math.log(Math.abs(num)) / Math.log(step));
    return (delimit(parseFloat((num / Math.pow(step, i)).toFixed(dm))) + separator + notations[i]).trim();
}
/**
 * Formats bytes into most-appropriate decimal notation.
 *
 * @param {number} bytes    Number of bytes
 * @param {number} decimals Number of decimal places
 * @returns {string} Human-readable file size string
 *
 * @example
 * formatBytes(1248) // "1,2 KB"
 * formatBytes(1248, 2) // "1,25 KB"
 * formatBytes(1248, 2, '.') // 1.25 KB
 */ function formatBytes(bytes) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var sizes = [
        "Byte",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ];
    return humanizeNumber(Math.abs(bytes), decimals, 1024, sizes, " ");
}

;// CONCATENATED MODULE: ./utils/datetime.ts




var locale = "id";
(0,esm/* register */.z2)(locale, function(_number, index, totalSec) {
    var translations = [
        [
            "baru saja",
            "sebentar"
        ],
        [
            "%s detik lalu",
            "dalam %s detik"
        ],
        [
            "1 menit lalu",
            "dalam 1 menit"
        ],
        [
            "%s menit lalu",
            "dalam %s menit"
        ],
        [
            "1 jam lalu",
            "dalam 1 jam"
        ],
        [
            "%s jam lalu",
            "dalam %s jam"
        ],
        [
            "1 hari lalu",
            "dalam 1 hari"
        ],
        [
            "%s hari lalu",
            "dalam %s hari"
        ],
        [
            "1 minggu lalu",
            "dalam 1 minggu"
        ],
        [
            "%s minggu lalu",
            "dalam %s minggu"
        ],
        [
            "1 bulan lalu",
            "dalam 1 bulan"
        ],
        [
            "%s bulan lalu",
            "dalam %s bulan"
        ],
        [
            "1 tahun lalu",
            "dalam 1 tahun"
        ],
        [
            "%s tahun lalu",
            "dalam %s tahun"
        ], 
    ];
    var translation = translations[index];
    if (translation[0].includes("minggu")) {
        var dayInSec = 86400;
        var days = Math.ceil(totalSec / dayInSec);
        return [
            "".concat(days, " hari lalu"),
            "dalam ".concat(days, " hari")
        ];
    }
    return translation;
});
var months = (/* unused pure expression or super */ null && ([
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember", 
]));
function humanizeDate(timestamp) {
    var dateObj = new Date(timestamp);
    var date = dateObj.getDate();
    var month = dateObj.getMonth();
    var year = dateObj.getFullYear();
    var hour = dateObj.getHours() > 9 ? dateObj.getHours() : "0" + dateObj.getHours();
    var minute = dateObj.getMinutes() > 9 ? dateObj.getMinutes() : "0" + dateObj.getMinutes();
    return "".concat(date, " ").concat(months[month], " ").concat(year, ", ").concat(hour, ":").concat(minute);
}
function youtubeDurationToSeconds(duration) {
    // https://developers.google.com/youtube/v3/docs/videos#contentDetails.duration
    var hours = 0;
    var minutes = 0;
    var seconds = 0;
    duration = duration.replace("PT", "");
    if (duration.indexOf("H") > -1) {
        var hoursSplit = duration.split("H");
        hours = parseInt(hoursSplit[0]);
        duration = hoursSplit[1];
    }
    if (duration.indexOf("M") > -1) {
        var minutesSplit = duration.split("M");
        minutes = parseInt(minutesSplit[0]);
        duration = minutesSplit[1];
    }
    if (duration.indexOf("S") > -1) {
        var secondsSplit = duration.split("S");
        seconds = parseInt(secondsSplit[0]);
    }
    return hours * 3600 + minutes * 60 + seconds;
}
function youtubeDurationToHms(duration) {
    var durationInSeconds = youtubeDurationToSeconds(duration);
    var hours = Math.floor(durationInSeconds / 3600);
    var minutes = Math.floor(durationInSeconds % 3600 / 60);
    var seconds = Math.floor(durationInSeconds % 3600 % 60);
    var hoursDisplay = hours > 0 ? String(hours).padStart(2, "0") + ":" : "";
    var minutesDisplay = String(minutes).padStart(2, "0") + ":";
    var secondsDisplay = String(seconds).padStart(2, "0");
    return hoursDisplay + minutesDisplay + secondsDisplay;
}
function timeAgo(datetime) {
    return (0,esm/* format */.WU)(datetime, locale);
}
function minuteToHour(minutes) {
    if (minutes < 60) {
        return "".concat(minutes, " menit");
    }
    return "".concat(roundWithPrecision(minutes / 60, 1), " jam");
}
function isoStringToDateInputTypeFormat(isoDateString) {
    var date = new Date(isoDateString);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var dt = date.getDate();
    var sday = dt.toString();
    var smonth = month.toString();
    if (dt < 10) {
        sday = "0" + dt.toString();
    }
    if (month < 10) {
        smonth = "0" + month.toString();
    }
    return year.toString() + "-" + smonth + "-" + sday;
}
function getTimestampForGTag() {
    var date = new Date();
    date = new Date(date.getTime() - 3000000);
    return date.getFullYear().toString() + "-" + ((date.getMonth() + 1).toString().length == 2 ? (date.getMonth() + 1).toString() : "0" + (date.getMonth() + 1).toString()) + "-" + (date.getDate().toString().length == 2 ? date.getDate().toString() : "0" + date.getDate().toString()) + " " + (date.getHours().toString().length == 2 ? date.getHours().toString() : "0" + date.getHours().toString()) + ":" + ((date.getMinutes() / 5 * 5).toString().length == 2 ? (date.getMinutes() / 5 * 5).toString() : "0" + (date.getMinutes() / 5 * 5).toString()) + ":00";
}
function formatDate(datetime) {
    var formatString = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "dd MMMM yyyy";
    return formatFns(new Date(datetime), formatString, {
        locale: id
    });
}


/***/ }),

/***/ 7379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ GATrackEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var configs_auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32178);
/* harmony import */ var utils_datetime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1413);



var getDefaultTrackerData = function() {
    var ref;
    var pathname = window.location.pathname;
    var userData = !!localStorage.getItem("app-login") ? JSON.parse(localStorage.getItem("app-login")) : false;
    var userId = localStorage.getItem(configs_auth__WEBPACK_IMPORTED_MODULE_0__/* .USER_ID_STORAGE_KEY */ .dV);
    var ref1;
    return {
        userId: !!userId && userId !== "null" ? userId : (ref1 = userData === null || userData === void 0 ? void 0 : (ref = userData.user) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : "null",
        timestamp: (0,utils_datetime__WEBPACK_IMPORTED_MODULE_1__/* .getTimestampForGTag */ .Sz)(),
        product: pathname.split("/")[1].replace("-", "_")
    };
};
var GATrackEvent = function(param) {
    var eventName = param.eventName, eventParams = param.eventParams, _sendDefaultParams = param.sendDefaultParams, sendDefaultParams = _sendDefaultParams === void 0 ? false : _sendDefaultParams;
    if (typeof gtag !== "undefined") {
        if (!!eventParams && !!eventParams["meta"] && typeof eventParams["meta"] === "object") {
            eventParams["meta"] = JSON.stringify(eventParams["meta"]);
        }
        gtag("event", eventName, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, sendDefaultParams && getDefaultTrackerData(), eventParams));
    }
};


/***/ }),

/***/ 97122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ analyticsEventHandler; }
/* harmony export */ });
// src/analytics-event-handler.ts
var isAnalyticsEventHandlerAvailable = function() {
    return  true && Boolean(window === null || window === void 0 ? void 0 : window.AnalyticsEventHandler);
};
function analyticsEventHandler() {
    return {
        enabled: isAnalyticsEventHandlerAvailable(),
        sendMoEngageEvent: function(eventName, payload) {
            var ref, ref1;
            return window === null || window === void 0 ? void 0 : (ref = window.AnalyticsEventHandler) === null || ref === void 0 ? void 0 : (ref1 = ref.sendMoEngageEvent) === null || ref1 === void 0 ? void 0 : ref1.call(ref, eventName, payload);
        }
    };
}



/***/ }),

/***/ 62587:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};


/***/ }),

/***/ 12361:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};


/***/ }),

/***/ 17673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(62587);
exports.encode = exports.stringify = __webpack_require__(12361);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1958,8189,1651,9291,615,1529,8785,9774,2888,179], function() { return __webpack_exec__(13908); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);